'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sanitize = exports.switchCase = undefined;

var _isFunction2 = require('lodash/isFunction');

var _isFunction3 = _interopRequireDefault(_isFunction2);

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _sanitizeHtml = require('sanitize-html');

var _sanitizeHtml2 = _interopRequireDefault(_sanitizeHtml);

var _decode = require('lean-he/lib/methods/decode');

var _decode2 = _interopRequireDefault(_decode);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var switchCase = exports.switchCase = function switchCase(_case, cases) {
  var defaults = {
    __default__: function __default__() {
      console.trace('** WARNING ** - unhandled default called for case', _case);
    }
  };

  cases = Object.assign(defaults, cases);

  return cases[_case] ? (0, _isFunction3.default)(cases[_case]) ? cases[_case]() : cases[_case] : (0, _isFunction3.default)(cases.__default__) ? cases.__default__() : cases.__default__;
};

var sanitize = exports.sanitize = function sanitize(obj) {
  if (!obj) {
    return obj;
  }

  var sanitizeOptions = {
    allowedTags: _sanitizeHtml2.default.defaults.allowedTags.concat(['img']),
    allowedAttributes: _extends({}, _sanitizeHtml2.default.defaults.allowedAttributes, {
      '*': ['style']
    })
  };

  return switchCase(typeof obj === 'undefined' ? 'undefined' : _typeof(obj), {
    __default__: obj,
    string: function string() {
      return (0, _decode2.default)((0, _sanitizeHtml2.default)(obj, sanitizeOptions)).replace(/[\n\r]+/g, '');
    },
    object: function object() {
      return Object.keys(obj).forEach(function (k) {
        return obj[k] = sanitize(obj[k]);
      }) || obj;
    }
  });
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/doctify-utils/lib/utils.js
// module id = 1531
// module chunks = 0